import React, { useEffect, useState } from "react";
import CircularProgress from "../../custom/circular-progress/CircularProgress";
import { useSelector } from "react-redux";
import { File } from "../../../services";

const LoaderProgress = () => {
    const { user } = useSelector(state => state);
    const [listDoc, setListDoc] = useState([]);

    useEffect(() => {
        getDocList();
    }, []);

    const getCurrentStage = () => {
        let stage = 0;

        if (user.emailConfirmed && user.emailConfirmed === true) {
            stage += 1;
        }
        if (listDoc.length >= 2) {
            stage += 1;
        }
        if (user.step === 2) {
            stage += 1;
        }

        return stage;
    };

    const getDocList = () => {
        if (user && user.id) {
            File.getDocList(user.id)
                .then((response) => {
                    setListDoc(response.data);
                })
                .catch((error) => {
                    console.log("Ошибка при получении списка документов:", error);
                });
        } else {
            setListDoc([]);
            console.log("Невозможно получить документы: ID пользователя не определен");
        }
    }

        return (
        <CircularProgress size={24} strokeWidth={2} stages={3} currentStage={getCurrentStage()} color="#048848" />
    )
}

export default LoaderProgress;